// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Signup-module__formContainer__TZPVR {
  max-width: 500px;
  margin: 0 auto;
}
.Signup-module__welcomeText__iDo_f {
  color: var(--golden-purple-7, #531dab) !important;
  font-family: Readex Pro !important;
  font-size: 42px !important;
  font-style: normal !important;
  font-weight: 500 !important;
  line-height: normal;
  margin-bottom: 10px !important;
}
.Signup-module__welcomeSub__udPJr {
  color: var(--neutral-7, #8c8c8c);
  font-family: Nunito;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.Signup-module__form__vro5g {
  margin-top: 50px;
}
.Signup-module__formLabel__qpipm {
  color: var(--character-title-85, rgba(0, 0, 0, 0.85));
  text-align: right;
  /* Body/regular */
  font-family: Nunito;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  /* 157.143% */
}
.Signup-module__text__hXJJl {
  color: var(--neutral-7, #8c8c8c);
  font-family: Nunito;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-align: center;
  display: block;
}
.Signup-module__text__hXJJl a {
  color: #4720c3;
}
.Signup-module__text__hXJJl a:hover {
  color: #531dab;
}
.Signup-module__email__cN8bF {
  text-decoration: underline;
}
.Signup-module__verifyContainer__rvxtG {
  text-align: center;
}
.Signup-module__verifyImage__Jzxm8 {
  width: 132px;
  height: 132px;
  flex-shrink: 0;
  background-color: var(--golden-purple-2, #efdbff);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 60px;
}
.Signup-module__loadingText__bijZ5 {
  font-size: 18px !important;
}
.Signup-module__loadingText__bijZ5 .loader {
  color: var(--golden-purple-7, #531dab) !important;
}
.Signup-module__prefixIcon__FmPdw {
  color: #d9d9d9 !important;
  margin-right: 6px;
  position: relative;
  top: 2px;
  font-size: 18px;
}
.ant-input-affix-wrapper-focused .Signup-module__prefixIcon__FmPdw {
  color: #8847ff !important;
}
.Signup-module__loginButton__nn81q:disabled {
  width: 100%;
  text-align: center;
}
.Signup-module__loginButton__nn81q:disabled:hover {
  background-color: rgba(0, 0, 0, 0.04) !important;
}
.Signup-module__loginButton__nn81q:enabled {
  width: 100%;
  text-align: center;
  border: 1px solid var(--golden-purple-6, #722ed1);
  background: #4720c3;
  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.04);
}
.Signup-module__loginButton__nn81q:enabled:hover {
  background: #4720c3 !important;
}
.Signup-module__helpText__lMCND {
  color: #cf2a38;
}
.Signup-module__termsText__np1ol {
  font-size: 11px;
  text-align: left;
}
.Signup-module__termsText__np1ol a {
  font-size: inherit;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Signup/Signup.module.less"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,cAAA;AACF;AACA;EACE,iDAAA;EACA,kCAAA;EACA,0BAAA;EACA,6BAAA;EACA,2BAAA;EACA,mBAAA;EACA,8BAAA;AACF;AACA;EACE,gCAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AACF;AACA;EACE,gBAAA;AACF;AACA;EACE,qDAAA;EACA,iBAAA;EACA,iBAAiB;EACjB,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAa;AACf;AACA;EACE,gCAAA;EAEA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AAAF;AATA;EAYI,cAAA;AAAJ;AAEI;EACE,cAAA;AAAN;AAKA;EACE,0BAAA;AAHF;AAMA;EACE,kBAAA;AAJF;AAOA;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,iDAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AALF;AAOA;EACE,0BAAA;AALF;AAIA;EAGI,iDAAA;AAJJ;AAQA;EACE,yBAAA;EACA,iBAAA;EAEA,kBAAA;EACA,QAAA;EACA,eAAA;AAPF;AAUA;EAEI,yBAAA;AATJ;AAaA;EACE,WAAA;EACA,kBAAA;AAXF;AAaE;EACE,gDAAA;AAXJ;AAeA;EACE,WAAA;EACA,kBAAA;EACA,iDAAA;EACA,mBAAA;EACA,+CAAA;AAbF;AAeE;EACE,8BAAA;AAbJ;AAiBA;EACE,cAAA;AAfF;AAkBA;EACE,eAAA;EACA,gBAAA;AAhBF;AAcA;EAKI,kBAAA;AAhBJ","sourcesContent":[".formContainer {\n  max-width: 500px;\n  margin: 0 auto;\n}\n.welcomeText {\n  color: var(--golden-purple-7, #531dab) !important;\n  font-family: Readex Pro !important;\n  font-size: 42px !important;\n  font-style: normal !important;\n  font-weight: 500 !important;\n  line-height: normal;\n  margin-bottom: 10px !important;\n}\n.welcomeSub {\n  color: var(--neutral-7, #8c8c8c);\n  font-family: Nunito;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.form {\n  margin-top: 50px;\n}\n.formLabel {\n  color: var(--character-title-85, rgba(0, 0, 0, 0.85));\n  text-align: right;\n  /* Body/regular */\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 22px; /* 157.143% */\n}\n\n.text {\n  color: var(--neutral-7, #8c8c8c);\n  text-align: center;\n  font-family: Nunito;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  text-align: center;\n  display: block;\n\n  a {\n    color: #4720c3;\n\n    &:hover {\n      color: #531dab;\n    }\n  }\n}\n\n.email {\n  text-decoration: underline;\n}\n\n.verifyContainer {\n  text-align: center;\n}\n\n.verifyImage {\n  width: 132px;\n  height: 132px;\n  flex-shrink: 0;\n  background-color: var(--golden-purple-2, #efdbff);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 60px;\n}\n.loadingText {\n  font-size: 18px !important;\n  :global(.loader) {\n    color: var(--golden-purple-7, #531dab) !important;\n  }\n}\n\n.prefixIcon {\n  color: #d9d9d9 !important;\n  margin-right: 6px;\n  // color: @login-text-color;\n  position: relative;\n  top: 2px;\n  font-size: 18px;\n}\n\n:global(.ant-input-affix-wrapper-focused) {\n  .prefixIcon {\n    color: #8847ff !important;\n  }\n}\n\n.loginButton:disabled {\n  width: 100%;\n  text-align: center;\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.04) !important;\n  }\n}\n\n.loginButton:enabled {\n  width: 100%;\n  text-align: center;\n  border: 1px solid var(--golden-purple-6, #722ed1);\n  background: #4720c3;\n  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.04);\n\n  &:hover {\n    background: #4720c3 !important;\n  }\n}\n\n.helpText {\n  color: #cf2a38;\n}\n\n.termsText {\n  font-size: 11px;\n  text-align: left;\n\n  a {\n    font-size: inherit;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formContainer": `Signup-module__formContainer__TZPVR`,
	"welcomeText": `Signup-module__welcomeText__iDo_f`,
	"welcomeSub": `Signup-module__welcomeSub__udPJr`,
	"form": `Signup-module__form__vro5g`,
	"formLabel": `Signup-module__formLabel__qpipm`,
	"text": `Signup-module__text__hXJJl`,
	"email": `Signup-module__email__cN8bF`,
	"verifyContainer": `Signup-module__verifyContainer__rvxtG`,
	"verifyImage": `Signup-module__verifyImage__Jzxm8`,
	"loadingText": `Signup-module__loadingText__bijZ5`,
	"prefixIcon": `Signup-module__prefixIcon__FmPdw`,
	"loginButton": `Signup-module__loginButton__nn81q`,
	"helpText": `Signup-module__helpText__lMCND`,
	"termsText": `Signup-module__termsText__np1ol`
};
export default ___CSS_LOADER_EXPORT___;
